<template>
  <div class="container1">
    <div>
      <Content class="content">
        <Table border :columns="queryColumn" :loading="loading" :data="queryData" ref="dataTable" center>
        </Table>
        <Row>
          <Col :md="24" class="pagination">
            <Page :total="totalRecord" :page-size="pageSize" :current="pageNum" :disabled="loading"
                  @on-change="pageChange" @on-page-size-change="pageSizeChange" show-elevator show-sizer show-total/>
          </Col>
        </Row>
      </Content>
    </div>
  </div>
</template>

<script>


import api from "@/api";

export default {
  name: 'ApplyMember',
  data() {
    return {
      queryData: [],
      totalRecord: 1,
      pageNum: 1,
      pageSize: 10,
      loading: false,
    }
  },
  computed: {
    queryColumn() {
      return [ {
        type: 'index',
        width: 60,
        align: 'center'
      },
        {
          title: '用户名',
          width: 150,
          key: 'userName',
          align: 'center'
        },
        {
          title: '手机号',
          width: 190,
          key: 'mobile',
          align: 'center'
        },
        {
          title: '报名岗位',
          minWidth: 200,
          key: 'jobName',
          align: 'center'
        },
        {
          title: '公司名称',
          minWidth: 200,
          key: 'company',
          align: 'center'
        },
        {
          title: '报名时间',
          width: 200,
          key: 'createTime',
          align: 'center'
        }
      ]
    },
  },
  created() {
    this.getData();
  },
  methods: {
    pageChange(pageNum) {
      this.pageNum = pageNum
      this.getData()
    },
    getData() {
      this.loading = true
      const queryParams = {
        page: this.pageNum,
        limit: this.pageSize,
        appChannel: 7
      }
      api.statistics
        .getApplyList(queryParams)
        .then(res => {
          if (res.code == 2000) {
            const result = res.data || {}
            this.totalRecord = result.totalRecordNum || 0
            this.queryData = result.records
          } else {
            this.$Message.error(res.msg)
          }
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          console.error('请求出错：', error)
        })
    },
    pageSizeChange(pageSize) {
      this.pageSize = pageSize
      this.pageNum === 1 ? this.getData() : (this.pageNum = 1)
    },
  }
};
</script>
<style scoped>
.content {
  padding: 24px;
  background: #fff;
  border-radius: 4px;
}

.container1 {
  background: #F6F7FB;
  height: 100vh;
  padding: 80px 20px 20px 20px;
}
</style>
